import React, { useEffect } from "react";
import { useState } from "react";
import { Box } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { toast } from "react-toastify";
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
// import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined'

// import { InicioGestionarCuenta } from './InicioGestionarCuenta';

import { InformacionPersonal } from "./InformacionPersonal";
// import { PagosSuscripciones } from './PagosSuscripciones';

import { AjustesPptos } from "../ajustes/pptos/AjustesPptos";
import { AjustesGastos } from "../ajustes/AjustesGastos";
// import { AjustesUsuariosVinculados } from '../ajustes/AjustesUsuariosVinculados'
// import { Seguridad } from './Seguridad'
import { InformacionEmpresa } from "./InformacionEmpresa";
// import { InformacionEmpresaOLD } from './InformacionEmpresaOLD'
import { EmailReportes } from "./EmailReportes";
import { Actividad } from "./Actividad";
import { Model } from "../../models/model";
import { Conexiones } from "./Conexiones";

export const GestionarCuentas = () => {
  const [value, setValue] = useState("1");

  useEffect(() => {
    setLogs();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (
      params.get("google") === "connected" ||
      params.get("google") === "drive_permission_required"
    ) {
      setValue("7");

      if (params.get("google") === "drive_permission_required") {
        toast.warning(
          "Para conectar Google Drive con Pretzu debes autorizar el acceso. Marcar la casilla.",
          {
            autoClose: false,
          },
        );
      }
    }
  }, []);

  const setLogs = async () => {
    await Model.save({
      url: "logs",
      dataForm: {
        modulo: "ajustes",
        accion: "ha ingresado a ajustes",
        comentario: "success: ingreso okey",
      },
      showMessage: false,
    });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        typography: "body1",
        background: "#ffff",
        borderRadius: "8px",
      }}
    >
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            orientation="horizontal"
            variant="scrollable"
            value={value}
            indicatorColor="secondary"
            aria-label="hotizontal tabs example"
          >
            <Tab
              label="Personal"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="1"
            />
            <Tab
              label="Empresa"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="2"
            />
            <Tab
              label="Ventas"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="3"
            />
            <Tab
              label="Gastos"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="4"
            />
            <Tab
              label="Email reportes"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="5"
            />
            <Tab
              label="Actividad"
              className="text-nowrap p-tab-gestioner-cuenta"
              value="6"
            />
            <Tab
              label="Conexiones"
              className="text-nowrap p-tab-gestioner-conexiones"
              value="7"
            />
            {/* <Tab icon={<AccountCircleIcon />} label="usuarios vinculados" className='text-nowrap p-tab-gestioner-cuenta' value="3" /> */}
            {/* <Tab icon={<CreditCardOutlinedIcon />} label="Pagos y suscripciones" className='text-nowrap p-tab-gestioner-cuenta' value="7" /> */}
          </TabList>
        </Box>

        <TabPanel value="1">
          <InformacionPersonal />
        </TabPanel>

        <TabPanel value="2">
          <InformacionEmpresa />
        </TabPanel>

        <TabPanel value="3">
          <AjustesPptos />
        </TabPanel>

        <TabPanel value="4">
          <AjustesGastos />
        </TabPanel>

        <TabPanel value="5">
          <EmailReportes />
        </TabPanel>

        <TabPanel value="6">
          <Actividad />
        </TabPanel>

        <TabPanel value="7">
          <Conexiones />
        </TabPanel>

        {/* <TabPanel value="3">
          <AjustesUsuariosVinculados />
        </TabPanel> */}

        {/*<TabPanel value="7">
          <PagosSuscripciones />
        </TabPanel> */}
      </TabContext>
    </Box>
  );
};
